<script setup>

const props = defineProps({
    message: Object
})

</script>
<template>
    <div class="relative">
        <div
            class="relative px-2 py-2 rounded-lg"
            :class="message.is_sender ? 'bg-gray-200' : 'bg-gray-100'"
        >
            {{ message.message }}
        </div>
        <div class="relative z-10 px-1">
            <div class="flex justify-between -mt-2 space-x-2">
                <div
                    :class="message.is_sender ? 'bg-gray-100' : 'bg-gray-200'"
                    class="rounded-full px-1 py-0.5 group cursor-default hover:pl-5 transition-all hover:pr-2 text-xs"
                >
                    <span class="block group-hover:hidden">
                        {{ message.initials }}
                    </span>
                    <span class="hidden group-hover:block">
                        {{ message.public_name }}
                    </span>
                </div>
                <div
                    :class="message.is_sender ? 'bg-gray-100' : 'bg-gray-200'"
                    class="cursor-default rounded-md px-1 py-0.5"
                >{{ message.created_at_pretty }}</div>
            </div>
            <div
                class="flex space-x-0.5 text-[9px] -mt-1 justify-end"
            >
                <div
                    v-for="(rs, i) in message.read_by_signature_requests_names"
                    :key="i"
                    class="relative flex items-center justify-center h-4 px-1 transition-all rounded-full cursor-default bg-myflowGreen-100 hover:bg-myflowGreen-200 group hover:px-2"
                >
                    <span class="block group-hover:hidden">
                        {{ rs.split(' ').map(name => name[0]).join('').toUpperCase() }}
                    </span>
                    <span class="hidden group-hover:block">
                        {{ rs }}
                    </span>
                </div>
            </div>
        </div>
        <div
            v-if="message.is_unread"
            @click="markAsRead"
            class="absolute w-3 h-3 rounded-full -top-1 -right-1 bg-myflowPurple"
        >
        </div>
    </div>
</template>
